import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { i18nHelper } from '../../../i18n/i18n';
import "../../../assets/css/pdpa_style.css";
import { ConsentDataResponseV2,  } from '@api/response/ConsentResponseV2';
import { Language, DateTimeFormat } from '@utils/constants/CommonConstants';
import { Dropdown } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { CommonHelper } from '@utils/helpers/CommonHelper';

interface IConsentModalProps {
    onAccept: () => void;
    onCancel: () => void;
    termsOfservice: ConsentDataResponseV2;
    privacyAndNotice: ConsentDataResponseV2;
}

export default function ConsentModalV2(
    props: React.PropsWithChildren<IConsentModalProps>
): React.FunctionComponentElement<IConsentModalProps> {

    const {
        onAccept,
        onCancel,
        termsOfservice,
        privacyAndNotice,
    } = props;

    const { i18n } = useTranslation();
    const currentLangItem = Language.getLangByKey(i18n.language.substring(0, 2));
    const languages = [Language.en, Language.th];

    const [termsActive, setTermsActive] = useState<string>('active');
    const [privacyActive, setPrivacyActive] = useState<string>('');
    const [terms, setTerms] = useState<string>('');
    const [privacy, setPrivacy] = useState<string>('');
    // const [acceptName, setAcceptName] = useState<string>('Common.Label.AccepTermAndConditionPrivacyPolicy') 

    useEffect(() => {

        if (termsOfservice.application !== '') {
            handleChangeTab('terms');
        } else if (privacyAndNotice.application !== '') {
            handleChangeTab('privacy');
        }

    }, []);

    // useEffect(() => {
    //     if (termsOfservice.application !== '' && privacyAndNotice.application !== '') {
    //         setAcceptName('Common.Label.AccepTermAndConditionPrivacyPolicy');
    //     } else if (termsOfservice.application !== '') {
    //         setAcceptName('Common.Label.AcceptTermAndCondition');
    //     } else if (privacyAndNotice.application !== '') {
    //         setAcceptName('Common.Label.AcceptPrivacyPolicy');
    //     }
    // }, [termsOfservice, privacyAndNotice]);

    useEffect(() => {
        handleChangeLanguage()
    }, [currentLangItem]);

    const handleChangeTab = (tab: string) => {
        if (tab === 'terms') {
            setTermsActive('active')
            setPrivacyActive('')
        } else if (tab == 'privacy') {
            setTermsActive('')
            setPrivacyActive('active')
        }
    }

    const handleChangeLanguage = () => {
        if (currentLangItem?.key === 'th') {
            setTerms(termsOfservice.descriptionTh);
            setPrivacy(privacyAndNotice.descriptionTh);
        } else {
            setTerms(termsOfservice.descriptionEn);
            setPrivacy(privacyAndNotice.descriptionEn);
        }
    }

    return (<>
        {
            <div style={{ backgroundColor: '#C6CACD', height: '100%', overflow: 'auto' }} className="modal-open modal-pdpa">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-body p-0 overflow-hidden">
                            <div className="nav-custom">
                                <div className="nav nav-tabs">
                                    {termsOfservice.application !== '' && (
                                        <a href="#" data-toggle="tab" className={`${termsActive}`} onClick={() => handleChangeTab('terms')}>{i18nHelper.translate('Common.Label.SCTermsAndConditionsV2')}</a>
                                    )}
                                    {privacyAndNotice.application !== '' && (
                                        <a href="#" data-toggle="tab" className={`${privacyActive}`} onClick={() => handleChangeTab('privacy')}>{i18nHelper.translate('Common.Label.SCPrivacyPolicyV2')}</a>
                                    )}

                                    <div className="lang" style={{ backgroundColor: '#f4f5f8' }}>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="" data-toggle="dropdown">
                                                <i className="icon-globe" style={{ zIndex: 1 }}>
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>{currentLangItem?.key.toUpperCase()}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                                {languages.map((lang) => {
                                                    return <Dropdown.Item onSelect={() => i18n.changeLanguage(lang.key)} key={'switch-lang-' + lang.key}>{lang.title}</Dropdown.Item>;
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div className={`tab-pane ${termsActive}`}>
                                        <h3 className='title-border' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {i18nHelper.translate('Common.Label.SCTermsAndConditionsTitleV2')}
                                            {termsOfservice?.lastUpdated && <span className='coc-last-updated'>{i18nHelper.translate('Common.Label.LastUpdated') + ' : ' + CommonHelper.displayDate(
                                                termsOfservice?.lastUpdated!,
                                                DateTimeFormat.DDMMYYYY_SLASH
                                            )}</span>}
                                        </h3>

                                        <div className='content-group'>
                                            <div dangerouslySetInnerHTML={{ __html: terms }} />
                                        </div>
                                    </div>
                                    <div className={`tab-pane ${privacyActive}`}>
                                        <h3 className='title-border' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {i18nHelper.translate('Common.Label.SCPrivacyPolicyTitleV2')}
                                            {privacyAndNotice?.lastUpdated && <span className='coc-last-updated'>{i18nHelper.translate('Common.Label.LastUpdated') + ' : ' + CommonHelper.displayDate(
                                                privacyAndNotice?.lastUpdated!,
                                                DateTimeFormat.DDMMYYYY_SLASH
                                            )}</span>}
                                        </h3>
                                        <div className='content-group'>
                                            <div dangerouslySetInnerHTML={{ __html: privacy }} />
                                            {/* {
                                                currentLangItem?.key === 'th' ?
                                                    <ReactMarkdown children={privacy} /> :
                                                    <div dangerouslySetInnerHTML={{ __html: privacy }} />
                                            } */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="float-custom">
                                {(termsOfservice.isNewVersion || privacyAndNotice.isNewVersion) ? (
                                    <>
                                        <button type="button" data-dismiss="modal" className="btn btn-noborder" onClick={() => onCancel()}>{i18nHelper.translate('Common.Button.Close')}</button>
                                        <button type="submit" className="btn btn-primary" onClick={() => onAccept()}>{i18nHelper.translate('Common.Label.Accept')}</button>
                                    </>
                                ) : (
                                    <button type="button" data-dismiss="modal" className="btn btn-noborder" onClick={() => onAccept()}>{i18nHelper.translate('Common.Button.Close')}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </>
    );
}
